import { createLucideIcon } from 'lucide-react'

export const Loading = createLucideIcon('Loading', [
  ['path', { d: 'M12 2v4', opacity: '0.1', key: 'Loading-0' }],
  ['path', { d: 'm16.2 7.8 2.9-2.9', opacity: '0.25', key: 'Loading-1' }],
  ['path', { d: 'M18 12h4', opacity: '0.3', key: 'Loading-2' }],
  ['path', { d: 'm16.2 16.2 2.9 2.9', opacity: '0.4', key: 'Loading-3' }],
  ['path', { d: 'M12 18v4', opacity: '0.6', key: 'Loading-4' }],
  ['path', { d: 'm4.9 19.1 2.9-2.9', opacity: '0.8', key: 'Loading-5' }],
  ['path', { d: 'M2 12h4', key: 'Loading-6' }],
  ['path', { d: 'm4.9 4.9 2.9 2.9', opacity: '0', key: 'Loading-7' }],
])

Loading.displayName = 'Loading'
